export default "__VITE_ASSET__CoU4D$zq__"